import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";

export const keyPaymentMethod: BaseKeyFunction = () => [
  "me",
  "payment",
  "method",
];
